module.exports = __webpack_public_path__ + "school/img/ebooksGdjyBg.d6b0521f.jpg";